<template>
	<module-tab name="运费模板" enable-flex @mounted="update" @activated="$refs.table.update()">
		<m-operate>
			<c-button color="main" @click="navigateTo('/freight_template_add')">新建运费模板</c-button>
		</m-operate>
		
		<c-table ref="table" height="grow">
			<c-table-column
				label="模板名称"
				name="name"
				width="200"
			></c-table-column>
			
			<c-table-column
				label="计费方式"
				name="type"
				width="80"
			>
				<template v-slot="{data}">
					<span v-if="data.type == 1" style="color:green">按件计费</span>
					<span v-else style="color:dodgerblue">按重计费</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="最后编辑时间"
				name="edit_date"
				width="140"
			></c-table-column>
			
			<c-table-column
				label="是否启用"
				width="120"
			>
				<template #default="{data}">
					<c-switch v-model="data.state" :state-value="[2, 1]" :state-text="['启用', '禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
        </template>
			</c-table-column>
			
			<c-table-column
				type="button"
				label="操作"
				width="120"
			>
				<template #default="{data}">
					<c-table-button @click="navigateTo(`/freight_template_edit/${data.id}`)">编辑</c-table-button>
					<c-table-button @click="deleteHandle(data.id,data.name)">删除</c-table-button >
				</template>
			</c-table-column>
		</c-table>
	</module-tab>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		
		methods: {
			update() {
				this.$refs.table.load({
					url: '/freight_template/list'
				});
			},
			
			stateHandle(state, next, data) {
				this.request({
					url: '/freight_template/state',
					data: {
						id: data.id,
						state: state ? 1 : 2
					},
					success: () => {
						next();
					}
				});
			},
			
			deleteHandle(id,name) {
				this.$confirm({
					message: '确定要删除运费模板【'+name+'】吗？',
					resolve: () => {
						this.request({
							url: '/freight_template/remove',
							data: {
								id
							},
							loading: true,
							success: () => {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style>
</style>